import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, of } from "rxjs";
import { UtilityService } from "services/utility.service";
import { DropDown } from "models";

@Injectable({ providedIn: "root" })
export class SystemSettingsService {
  systemSettingsUrl = environment.config.systemSettings;
  IecMonitoringUrl = environment.baseUrl;
  apiUrl = environment.config.apiUrl;
  constructor(private http: HttpClient, private util: UtilityService) {}

  getStateDropdown() {
    if (
      this.util.getAccessLevel() === "STATE" ||
      this.util.getAccessLevel() === "DISTRICT" ||
      this.util.getAccessLevel() === "ULB"
    ) {
      const accessData = this.util.getAccessData();
      const option: DropDown[] = [];
      option.push({
        name: accessData.stateName,
        code: accessData.stateCode,
        codeName: accessData.stateShortName,
        id: accessData.stateId,
      });
      return of({ data: option, disable: true });
    }
    return this.http.get(this.systemSettingsUrl + "state/drop");
  }
  getAllStateDropdown() {
    return this.http.get(this.systemSettingsUrl + "state/drop");
  }
  getApprovalAndFinancialProgress(queryData) {
    // const params = new HttpParams().set('stateId', stateId.toString());
    // return this.http.get(`${this.baseUrl}/dashboard/fact/sheet/approval/and/financial/progress`, { params });
     return this.http.get(this.apiUrl + "dashboard/fact/sheet/approval/and/financial/progress",{
      params: queryData,
    });
  }
  getVisibleCleanlinessIndicators(queryData) {    
    return this.http.get(this.apiUrl + "dashboard/fact/sheet/ss/visible/cleanliness/indicators", {
      params: queryData,
    });
  } 
  getWasteCollectionAndSegregation(queryData) { 
      return this.http.get(this.apiUrl + "dashboard/fact/sheet/waste-collection-and-Segregation", {
      params: queryData,
    });
  } 
  getSwmPlants(queryData) {
    return this.http.get(this.apiUrl + "dashboard/fact/sheet/swm-plants", {
      params: queryData,
    });
  }
  getDistrictDropdown(stateId) {    
    if (
      this.util.getAccessLevel() === "DISTRICT" ||
      this.util.getAccessLevel() === "ULB"
    ) {
      const accessData = this.util.getAccessData();
      const option: DropDown[] = [];
      option.push({
        name: accessData.districtName,
        code: accessData.districtCode,
        codeName: accessData.districtShortName,
        id: accessData.districtId,
      });
      return of({ data: option, disable: true });
    }
    return this.http.get(this.systemSettingsUrl + "district/drop/" + stateId);
  }
  getAllDistrictDropdown(stateId) {
    return this.http.get(this.systemSettingsUrl + "district/drop/" + stateId);
  }

  getULBDropdown(districtId) {
    if (this.util.getAccessLevel() === "ULB") {
      const accessData = this.util.getAccessData();
      const option: DropDown[] = [];
      option.push({
        name: accessData.ULBName,
        code: accessData.ULBCode,
        codeName: "",
        id: accessData.ULBId,
      });
      return of({ data: option, disable: true });
    }
    return this.http.get(this.systemSettingsUrl + "ulb/drop/" + districtId);
  }
  getAllULBDropdown(districtId) {
    return this.http.get(this.systemSettingsUrl + "ulb/drop/" + districtId);
  }

  getWardDropdown(ulbId) {
    return this.http.get(this.systemSettingsUrl + "ward/drop/" + ulbId);
  }

  fetchVendorDropdown(params) {
    return this.http.get<any>(
      environment.config.vendorUrl + "cityprofile/dropDown",
      { params }
    );
  }

  getTypes = (query: string, store: Array<any>, endpoint = "type/") => {
    store.length = 0;
    this.getDynamicTypeDropDown(query, endpoint).subscribe((res) => {
      // res.data.rows.sort((a, b) => a.name.localeCompare(b.name));
      const options = res.data?.rows?.length ? [...res.data.rows] : [];
      options.forEach((x) => {
        store.push(x);
      });
    });
  };

  getTypesV2 = (
    obj,
    store: Array<any>,
    subscriberBs: BehaviorSubject<any> = null
  ) => {
    store.length = 0;
    this.getPlantTypesMapping(this.util.nullCheckObj(obj)).subscribe((res) => {
      const options = res.data?.length ? [...res.data] : [];
      options.forEach((x) => {
        store.push(x);
      });
      subscriberBs.next(store);
    });
  };

  // Common CRUD methods......
  save(url: string, data) {
    return this.http.post<any>(this.systemSettingsUrl + url, data);
  }
  update(url: string, id, data) {
    return this.http.put<any>(this.systemSettingsUrl + url + id, data);
  }
  delete(url: string, id) {
    return this.http.delete<any>(this.systemSettingsUrl + url + id);
  }
  getDetail(url: string, id) {
    return this.http.get<any>(this.systemSettingsUrl + url + id);
  }
  getList(url: string, queryData) {
    return this.http.get<any>(this.systemSettingsUrl + url, {
      params: queryData,
    });
  }

  getSubTypesById(id) {
    return this.http.get<any>(this.systemSettingsUrl + "type/new/" + id);
  }
  getFormList(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "form", {
      params: queryData,
    });
  }
  getFormDetail(id) {
    return this.http.get<any>(this.systemSettingsUrl + "form/admin/" + id);
  }
  getApplicaitons() {
    return this.http.get<any>(this.systemSettingsUrl + "application/drop");
  }
  getModules(id) {
    return id
      ? this.http.get<any>(this.systemSettingsUrl + "module/drop/" + id)
      : of(null);
  }
  getApplicaitonByid() {
    return this.http.get<any>(this.systemSettingsUrl + "application/drop/drop");
  }
  getSubModules(id) {
    return id
      ? this.http.get<any>(this.systemSettingsUrl + "submodule/drop/" + id)
      : of(null);
  }
  hsgFunderBy(typeName) {
    return typeName
      ? this.http.get<any>(this.systemSettingsUrl + "type/" + typeName)
      : of(null);
  }
  SWMOfHsg(typeName) {
    return typeName
      ? this.http.get<any>(this.systemSettingsUrl + "type/" + typeName)
      : of(null);
  }
  sanitationOfHsg(typeName) {
    return typeName
      ? this.http.get<any>(this.systemSettingsUrl + "type/" + typeName)
      : of(null);
  }
  toggleFormStatus(id) {
    return this.http.get<any>(this.systemSettingsUrl + "form/status/" + id);
  }
  toggleFormFieldStatus(id) {
    return this.http.get<any>(
      this.systemSettingsUrl + "form/attributes/status/" + id
    );
  }

  getTypeDropDown(type: string) {
    return this.http.get<any>(this.systemSettingsUrl + "form/type/" + type);
  }
  getFormJson(id) {
    return this.http.get<any>(this.systemSettingsUrl + "form/" + id);
  }
  getDynamicTypeDropDown(type: string, endpoint = "type/") {
    return this.http.get<any>(this.systemSettingsUrl + endpoint + type);
  }
  dropdownFocusArea(type: string, endpoint = "project/cb/dropdownFocusArea/") {
    return this.http.get<any>(environment.config.pts + endpoint + type);
  }
  dropdownWorkerMapping(
    queryData,
    endpoint = "project/cb/dropdownWorkerMapping/"
  ) {
    return this.http.get<any>(environment.config.pts + endpoint, {
      params: queryData,
    });
  }
  getDynamicFieldsUnits(type: string, queryData = {}) {
    return this.http.get<any>(this.systemSettingsUrl + `type/${type}/units`, {
      params: queryData,
    });
  }
  getMappedTypeDropDown(typeId: string, queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "type/" + typeId, {
      params: queryData,
    });
  }
  addFormAndFormField(data) {
    return this.http.post<any>(this.systemSettingsUrl + "form", data);
  }
  getVehicleCapacity(query) {
    return this.http.get<any>(
      this.systemSettingsUrl + `type/vehicle/capacity`,
      { params: query }
    );
  }
  updateFormAndFormField(data) {
    console.log(this.systemSettingsUrl + "form");
    return this.http.put<any>(this.systemSettingsUrl + "form", data);
  }

  // Plant Type-Subtype V2
  getPlantTypesMapping(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "type/plant/drop/down", {
      params: queryData,
    });
  }
  getPlantDynamicTypeDropDown(type: string) {
    return this.http.get<any>(this.systemSettingsUrl + "facility/type/" + type);
  }

  fetchAgencyDrop() {
    return this.http.get<any>(this.systemSettingsUrl + "agencyType/drop/down");
  }

  fetchAgencyOptions() {
    return this.http.get<any>(this.systemSettingsUrl + "agency/drop/down");
  }

  fetchDepartmentDropdown() {
    return this.http.get<any>(this.systemSettingsUrl + "department/drop/down");
  }

  fetchDesignationOptions(query = {}) {
    return this.http.get<any>(
      this.systemSettingsUrl + "designation/drop/down",
      { params: query }
    );
  }

  fetchAccessOptions() {
    return this.http.get<any>(
      this.systemSettingsUrl + "access/level/drop/down"
    );
  }

  // Forms Utility Version 2
  // -----------------------

  // Form Mapping
  getFormsDropdown() {
    return this.http.get<any>(
      this.systemSettingsUrl + "new/form/mapping/dropdown"
    );
  }
  getGroupsDropdown(formId) {
    return this.http.get<any>(
      this.systemSettingsUrl + `new/form/mapping/group/dropdown/${formId}`
    );
  }
  saveFormMapping(data) {
    return this.http.post<any>(
      this.systemSettingsUrl + "new/form/mapping/",
      data
    );
  }
  getFormMapping(id) {
    return this.http.get<any>(
      this.systemSettingsUrl + "new/form/mapping/" + id
    );
  }
  updateFormMapping(id, data) {
    return this.http.put<any>(
      this.systemSettingsUrl + "new/form/mapping/" + id,
      data
    );
  }
  formMappingList(query) {
    return this.http.get<any>(this.systemSettingsUrl + "new/form/mapping/", {
      params: query,
    });
  }

  // Form Fields V2
  getGroupedFormJson(query) {
    return this.http.get<any>(this.systemSettingsUrl + "new/form/alpha/form", {
      params: query,
    });
  }

  saveFormFieldV2(data) {
    return this.http.post<any>(this.systemSettingsUrl + "new/form", data);
  }
  updateFormFieldV2(data) {
    return this.http.put<any>(this.systemSettingsUrl + "new/form", data);
  }
  getFormListV2(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "new/form", {
      params: queryData,
    });
  }
  getFormDetailV2(id) {
    return this.http.get<any>(this.systemSettingsUrl + "new/form/sysuser/" + id);
  }

  getOtherUlb(val, data) {
    return this.http.get<any>(this.systemSettingsUrl + "ULB/drop/all/" + val, {
      params: data,
    });
  }
  toggleFormV2Status(id) {
    return this.http.get<any>(this.systemSettingsUrl + "new/form/status/" + id);
  }
  toggleFormFieldV2Status(id) {
    return this.http.get<any>(
      this.systemSettingsUrl + "new/form/attributes/status/" + id
    );
  }

  // Type-Subtypes
  getTypesList(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "type/alpha/ui/", {
      params: queryData,
    });
  }
  getTypeMasterDropDown() {
    return this.http.get<any>(this.systemSettingsUrl + "type/drop/down");
  }
  getType(id) {
    return this.http.get<any>(this.systemSettingsUrl + "type/alpha/ui/" + id);
  }
  saveType(data) {
    return this.http.post<any>(this.systemSettingsUrl + "type/alpha/ui/", data);
  }
  updateType(id, data) {
    return this.http.put<any>(
      this.systemSettingsUrl + "type/alpha/ui/" + id,
      data
    );
  }

  // Types for Plants
  getPlantTypesList(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "facility/type/", {
      params: queryData,
    });
  }
  getPlantTypeMasterDropDown() {
    return this.http.get<any>(
      this.systemSettingsUrl + "facility/type/drop/down"
    );
  }
  getPlantType(id) {
    return this.http.get<any>(this.systemSettingsUrl + "facility/type/" + id);
  }
  savePlantType(data) {
    return this.http.post<any>(this.systemSettingsUrl + "facility/type/", data);
  }
  updatePlantType(id, data) {
    return this.http.put<any>(
      this.systemSettingsUrl + "facility/type/" + id,
      data
    );
  }

  getPlantSubTypesList(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "facility/subtype/", {
      params: queryData,
    });
  }
  getPlantSubTypeMasterDropDown(id) {
    return this.http.get<any>(
      this.systemSettingsUrl + "facility/subtype/drop/down/" + id
    );
  }
  getPlantSubType(id) {
    return this.http.get<any>(
      this.systemSettingsUrl + "facility/subtype/" + id
    );
  }
  savePlantSubType(data) {
    return this.http.post<any>(
      this.systemSettingsUrl + "facility/subtype/",
      data
    );
  }
  updatePlantSubType(id, data) {
    return this.http.put<any>(
      this.systemSettingsUrl + "facility/subtype/" + id,
      data
    );
  }

  getSubTypesList(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "subtype/alpha/ui/", {
      params: queryData,
    });
  }
  getSubTypeMasterDropDown() {
    return this.http.get<any>(this.systemSettingsUrl + "subtype/drop/down");
  }
  getSubType(id) {
    return this.http.get<any>(
      this.systemSettingsUrl + "subtype/alpha/ui/" + id
    );
  }
  saveSubType(data) {
    return this.http.post<any>(
      this.systemSettingsUrl + "subtype/alpha/ui/",
      data
    );
  }
  updateSubType(id, data) {
    return this.http.put<any>(
      this.systemSettingsUrl + "subtype/alpha/ui/" + id,
      data
    );
  }

  getTypeSubTypeMappingList(queryData) {
    return this.http.get<any>(
      this.systemSettingsUrl + "type/mapping/alpha/ui/",
      { params: queryData }
    );
  }
  getTypeSubTypeMapping(id) {
    return this.http.get<any>(
      this.systemSettingsUrl + "type/mapping/alpha/ui/" + id
    );
  }
  saveTypeSubTypeMapping(data) {
    return this.http.post<any>(
      this.systemSettingsUrl + "type/mapping/alpha/ui/",
      data
    );
  }
  updateTypeSubTypeMapping(id, data) {
    return this.http.put<any>(
      this.systemSettingsUrl + "type/mapping/alpha/ui/" + id,
      data
    );
  }

  getPlantTypeMappingList(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "type/plant/alpha/ui/", {
      params: queryData,
    });
  }
  getPlantTypeMapping(id) {
    return this.http.get<any>(
      this.systemSettingsUrl + "type/plant/alpha/ui/" + id
    );
  }
  savePlantTypeMapping(data) {
    return this.http.post<any>(
      this.systemSettingsUrl + "type/plant/alpha/ui/",
      data
    );
  }
  updatePlantTypeMapping(id, data) {
    return this.http.put<any>(
      this.systemSettingsUrl + "type/plant/alpha/ui/" + id,
      data
    );
  }

  getFAQList(queryData) {
    return this.http.get<any>(this.systemSettingsUrl + "faq/", {
      params: queryData,
    });
  }
  getFAQ(id) {
    return this.http.get<any>(this.systemSettingsUrl + "faq/" + id);
  }
  saveFAQ(data) {
    return this.http.post<any>(this.systemSettingsUrl + "faq/", data);
  }
  updateFAQ(id, data) {
    return this.http.put<any>(this.systemSettingsUrl + "faq/" + id, data);
  }

  getManuals() {
    return this.http.get<any>(this.systemSettingsUrl + "userManual/", {
      headers: { skip: "true" },
    });
  }

  // template
  getTemplateList(query) {
    return this.http.get<any>(this.systemSettingsUrl + "template/", {
      params: query,
    });
  }
  getTemplate(id) {
    return this.http.get<any>(this.systemSettingsUrl + "template/" + id);
  }
  saveTemplate(data) {
    return this.http.post<any>(this.systemSettingsUrl + "template/", data);
  }
  updateTemplate(id, data) {
    return this.http.put<any>(this.systemSettingsUrl + "template/" + id, data);
  }

  getIecOptions(endpoint:string){
    return this.http.get<any>(this.IecMonitoringUrl + '/api/v1/proposal/project/iec/' + endpoint )
  }
}
